import type {
  AxiosError,
  AxiosInstance,
  AxiosRequestHeaders,
  AxiosResponse,
  InternalAxiosRequestConfig,
} from "axios";
import {
  LocalStorage,
  LocalStorageKeys,
} from "../../utils/local-storage.utils";

const onRequest = (
  config: InternalAxiosRequestConfig
): InternalAxiosRequestConfig => {
  const match = window.location.pathname.match(
    /ephemeral\/brand-dash\/([^/]+)/
  );
  const campaignId = match ? match[1] : "";
  const authToken = LocalStorage.getInstance().get(LocalStorageKeys.token);
  const authEphemerealToken = LocalStorage.getInstance().get(
    `@dash/ephemeral/brand-dash/${campaignId}` as LocalStorageKeys
  );

  const token = window.location.pathname.startsWith("/ephemeral/brand-dash/")
    ? authEphemerealToken
    : authToken;
  config.headers["client-interface"] = "memed_dashboard";

  if (!config.headers) config.headers = {} as AxiosRequestHeaders;
  if (!token) return config;

  config.headers.Authorization = `Bearer ${token}`;

  return config;
};

const onRequestError = (error: AxiosError): Promise<AxiosError> => {
  console.error(`[request error] [${JSON.stringify(error)}]`);
  return Promise.reject(error);
};

const onResponse = (response: AxiosResponse): AxiosResponse => {
  console.info(`[response] [${JSON.stringify(response)}]`);
  return response;
};

const onResponseError = (error: AxiosError): Promise<AxiosError> => {
  console.error(`[response error] [${JSON.stringify(error)}]`);
  return Promise.reject(error);
};

export function setupInterceptorsTo(
  axiosInstance: AxiosInstance
): AxiosInstance {
  axiosInstance.interceptors.request.use(onRequest, onRequestError);
  axiosInstance.interceptors.response.use(onResponse, onResponseError);
  return axiosInstance;
}
